import React from 'react';
import { Link } from 'react-router-dom';
import '../../../global.css';
import Navbar from '../../../components/Navbar';
import SiteFooter from '../../../components/SiteFooter';
import NeuralCanvas from '../../../components/NeuralCanvas';
import { useSEO } from '../../../hooks/useSEO';
import safetyHero from '../../../assets/images/agric.jpeg'; // Import your local image

export default function Agriculture() {
  useSEO({
    title: 'Agriculture AI for African Farmers',
    description: 'A farming expert in every pocket — crop disease detection, local language advisory, and yield intelligence built for Africa\'s smallholder farmers.',
    path: '/solutions/agriculture',
  });
  return (
    <>
      <NeuralCanvas />
      <div className="neural-page">
      <Navbar />

      <div style={{ borderBottom: '1px solid var(--line)', padding: '80px 0 72px' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--accent)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 20 }}>SOLUTION · AGRICULTURE</div>
          <div className="sol-hero-grid">
            <div>
              <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 400, letterSpacing: '-0.04em', lineHeight: 1.05, marginBottom: 20 }}>
                A farming expert<br /><span style={{ color: 'var(--fg-mid)', fontWeight: 300 }}>in every pocket.</span>
              </h1>
              <p style={{ fontSize: 16, color: 'var(--fg-mid)', lineHeight: 1.7, maxWidth: 480, marginBottom: 32 }}>
                A farmer in Kano takes a photo of a sick crop on a $10 phone. In seconds, Cybernate identifies the disease
                and replies in Hausa with exactly what to do. No agronomist. No internet required.
                60% of Africans farm — now they all have an expert.
              </p>
              <div style={{ display: 'flex', gap: 12 }}>
                <Link to="/signup" className="btn btn-primary">Get started →</Link>
                <Link to="/developers" className="btn btn-ghost">Developer platform</Link>
              </div>
            </div>
            
      <div style={{ padding: '56px 0 0' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          <div style={{
            width: '100%',
            height: 'clamp(220px, 42vw, 480px)',
            borderRadius: 'var(--r-lg)',
            overflow: 'hidden',
            border: '1px solid var(--line)',
            background: 'var(--bg-1)',
          }}>
            <img
              src={safetyHero}
              alt="African farmer in the field using a mobile phone"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>

      <div style={{ borderBottom: '1px solid var(--line)', padding: '40px 0', background: 'var(--bg-1)' }}>
        <div className="sol-stats-grid" style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          {[['60%', 'of Africa\'s workforce in agriculture'], ['18', 'Languages for advisory'], ['94%', 'Disease detection accuracy'], ['48h', 'Planting advisory lead time']].map(([n, l], i) => (
            <div key={n} style={{ padding: '24px 32px', borderRight: i < 3 ? '1px solid var(--line)' : 'none' }}>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 28, fontWeight: 500, letterSpacing: '-0.04em', color: 'var(--fg)', marginBottom: 6 }}>{n}</div>
              <div style={{ fontSize: 12, color: 'var(--fg-dim)' }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
{/* 
      <div style={{ padding: '56px 0 0' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          <div style={{
            width: '100%',
            height: 'clamp(220px, 42vw, 480px)',
            borderRadius: 'var(--r-lg)',
            overflow: 'hidden',
            border: '1px solid var(--line)',
            background: 'var(--bg-1)',
          }}>
            <img
              src={safetyHero}
              alt="African farmer in the field using a mobile phone"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
              loading="lazy"
            />
          </div>
        </div>
      </div> */}
     

      <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '72px var(--pad-x)' }}>
        <h2 style={{ fontSize: 32, fontWeight: 400, letterSpacing: '-0.03em', marginBottom: 48 }}>Agricultural intelligence<br /><span style={{ color: 'var(--fg-mid)', fontWeight: 300 }}>rooted in African reality.</span></h2>
        <div className="sol-features-grid">
          {[
            { title: 'Crop disease diagnosis', desc: 'Identify cassava mosaic, maize streak, and 50+ other African crop diseases from a phone photo. Accuracy tested on African field conditions.' },
            { title: 'Voice advisory', desc: 'Farmers ask questions in Hausa, Yoruba, or Swahili via voice note. Cybernate answers in the same language with agronomic precision.' },
            { title: 'Yield forecasting', desc: 'Forecast yields for cassava, maize, sorghum, and cocoa based on African soil data, rainfall patterns, and input conditions.' },
            { title: 'Market price alerts', desc: 'Monitor commodity prices at regional markets and alert farmers when to sell. Integrations with AFEX and other African commodity exchanges.' },
            { title: 'Soil analysis', desc: 'Analyze soil photos and GPS data to provide fertilizer recommendations calibrated for African soil types.' },
            { title: 'Extension worker tools', desc: 'Give extension officers an AI assistant that helps them advise hundreds of farmers per day, with reports in their local language.' },
          ].map(u => (
            <div key={u.title} style={{ padding: '24px', background: 'var(--bg-1)', border: '1px solid var(--line)', borderRadius: 'var(--r-md)' }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--fg)', marginBottom: 8 }}>{u.title}</div>
              <div style={{ fontSize: 13, color: 'var(--fg-dim)', lineHeight: 1.65 }}>{u.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderTop: '1px solid var(--line)', padding: '64px 0', background: 'var(--bg-1)' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', textAlign: 'center', padding: '0 var(--pad-x)' }}>
          <h2 style={{ fontSize: 28, fontWeight: 400, letterSpacing: '-0.03em', marginBottom: 12 }}>Give every farmer a trusted expert.</h2>
          <p style={{ fontSize: 14, color: 'var(--fg-mid)', marginBottom: 28 }}>Free to start. Works in 18 languages. No credit card required.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Link to="/signup" className="btn btn-primary btn-lg">Get started →</Link>
            <Link to="/developers" className="btn btn-ghost btn-lg">Developer docs</Link>
          </div>
        </div>
      </div>

      <SiteFooter />
      </div>
    </>
  );
}
